import { Component, OnInit, ViewChild } from "@angular/core";
import { VernostServiceService } from "../../services/vernost-service.service";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-override-price",
  templateUrl: "./override-price.component.html",
  styleUrls: ["./override-price.component.css"],
  providers: [DatePipe]
})
export class OverridePriceComponent implements OnInit {
  @ViewChild("input1", { read: MatInput }) input1: MatInput;
  @ViewChild("input2", {read: MatInput }) input2: MatInput;
  modalRef: BsModalRef;
  IsEmptyVal: boolean = false;
  isEndDate: boolean = true;
  showsingle: boolean = false;
  isFromDateFilled: boolean = false;
  showMultiple: boolean = false;
  final: any;
  disablebtn: boolean = false;
  tiers: any[];
  myDate: any = new Date();
  invaliddate: boolean = false;
  listPrice: any = [];
  price: any = {};
  noresult: any = "";
  loader: any = false;
  searchlist: boolean = true;
  p: number = 1;
  totalItems: number = 1;
  deleteID: any = "";
  editID: any = "";
  viewpage = false;
  actionmode: any = "Search";
  showList: boolean = false;
  selectedValue: any;
  islabel: boolean;
  issave: boolean = false;
  isediticon: boolean = true;
  iscancel: boolean;

  selectedItems = [];
  dropdownSettings = {};

  toDateflag: boolean = false;

  constructor(
    public vernostServiceService: VernostServiceService,
    private toastService: ToastrService,
    private modalService: BsModalService
  ) { }

  ishidden: boolean;
  ngOnInit() {
    // this.tiers = ["RED", "SILVER", "GOLD", "PLATINUM"];
    this.ishidden = false;
    this.islabel = true;
    this.tiers = [
      { item_id: 1, item_text: 'RED' },
      { item_id: 2, item_text: 'SILVER' },
      { item_id: 3, item_text: 'GOLD' },
      { item_id: 4, item_text: 'PLATINUM' },

    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

  }

  keyupevent(event: any) {
    const pattern = /^[a-zA-Z]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^a-zA-Z]/g, "");
    }
    if (
      this.price.origin &&
      this.price.origin.length == 3 &&
      this.price.destination &&
      this.price.destination.length == 3
    ) {
      this.searchTpmData();
    }
  }

  openModal(content) {
    this.modalRef = this.modalService.show(content);
  }

  closeModal() {
    this.modalRef.hide();
  }

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
    //this.resetPrice();
  }

  searchForm() {
    this.viewpage = false;
    this.actionmode = "Search";
    this.resetPrice();
  }

  setToDate(date) {
    this.price.TO_DATE = date;
  }

  resetFrom() {
    this.input1.value = "";
    this.input2.value = "";
    this.price.FROM_DATE = "";
    this.price.TO_DATE = "";
    this.isFromDateFilled = false;
    this.isEmpty("");
  }

  clearToDate() {
    this.input2.value = "";
    this.price.TO_DATE = "";
  }

  resetTo(event) {
    this.price.TO_DATE = "";
    this.isEmpty("");
  }

  checkDate() {
    this.invaliddate = false;
    if (
      this.price.TO_DATE != " " &&
      this.price.TO_DATE != "" &&
      this.price.TO_DATE != null
    ) {
      if (this.price.FROM_DATE >= this.price.TO_DATE) {
        this.invaliddate = true;
      }
    }
  }

  isEmpty(event) {
    if (this.price.FROM_DATE == "" || this.price.TO_DATE == "") {
      this.IsEmptyVal = false;
    } else {
      this.IsEmptyVal = true;
    }
  }

  incresedate() {
    let tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    let tam = new Date(tomorrow);
    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);
    this.isFromDateFilled = true;
    if (!!this.price.FROM_DATE) {
      this.isEndDate = false;
    }
  }

  checkStatusFrom() {
    this.myDate = this.price.FROM_DATE;
    this.checkempty();
    this.showsingle = true;
    this.showMultiple = true;

    if (this.price.FROM_DATE != "" && this.price.TO_DATE != "") {
      this.isEndDate = false;
    } else {
      this.myDate = new Date();
      this.isEndDate = true;
      this.price.TO_DATE = "";
    }
  }

  checkempty() {
    if (this.price.FROM_DATE != "" && this.price.TO_DATE != "") {
      this.disablebtn = false;
    }

    if (this.price.FROM_DATE == "" && this.price.TO_DATE == "") {
      this.disablebtn = false;
    }

    if (this.price.FROM_DATE == "" && this.price.TO_DATE != "") {
      this.disablebtn = true;
    }

    if (this.price.FROM_DATE != "" && this.price.TO_DATE == "") {
      this.disablebtn = true;
    }
  }

  createPrice = () => {
    if (this.price.tier == undefined) {
      this.price.tier = []
    }

    let message = this.price.tier.length == 0
      ? "Enter Tier Type"
      : !this.price.origin.toUpperCase()
        ? "Enter Origin"
        : !this.price.destination.toUpperCase()
          ? "Enter Destination"
          : !this.price.tpmValue
            ? "Enter TPM value"
            : !this.price.FROM_DATE
              ? "Please Select From Date"
              : !this.price.TO_DATE
                ? "Please Select To Date"
                : !this.price.fp1
                  ? "Enter Fare Product"
                  : !this.price.fp2
                    ? "Enter Fare Product"
                    : !this.price.fp3
                      ? "Enter Fare Product"
                      : !this.price.fp4
                        ? "Enter Fare Product"
                        : !this.price.fp5
                          ? "Enter Fare Product"
                          : !this.price.fp6
                            ? "Enter Fare Product"
                            : !this.price.fp7
                              ? "Enter Fare Product"
                              : null;

    if (!!message) {
      this.toastService.error(message, "Alert");
    } else {
      this.price.FROM_DATE = moment(this.price.FROM_DATE).format("YYYY-MM-DD");
      this.price.TO_DATE = moment(this.price.TO_DATE).format("YYYY-MM-DD");
      this.price.origin = this.price.origin.toUpperCase();
      this.price.destination = this.price.destination.toUpperCase();
      this.price.USER_ID = localStorage.getItem("uid");
      let tiersList = []
      if (this.price.tier.length != 0) {
        this.price.tier.forEach(element => {
          tiersList.push(element.item_text)
        });
        this.price.tier = tiersList;
      }
      console.log(this.price, "CREATEEEEEE");
      this.vernostServiceService.createPrice(this.price).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.searchPrice();
            this.resetPrice();
            this.viewpage = false;
            this.actionmode = "Search";
            this.toastService.success("Successfully Updated.");
          } else if (res.status == 409) {
            //this.toastService.error("Already exist, Please enter valid data!");
            this.toastService.error(res.message);
          }
        },
        err => {
          if (err.status == 409) {
            this.toastService.error("Already exist, Please enter valid data!");
          } else {
            this.toastService.error(err.message);
          }
        }
      );
    }
  };
  searchPrice() {
    this.loader = true;
    if (this.price.FROM_DATE) {
      this.price.FROM_DATE = moment(this.price.FROM_DATE).format("YYYY-MM-DD");
    }
    if (this.price.TO_DATE) {
      this.price.TO_DATE = moment(this.price.TO_DATE).format("YYYY-MM-DD");
    }
    if (this.price.origin) {
      this.price.origin = this.price.origin.toUpperCase();
    }
    if (this.price.destination) {
      this.price.destination = this.price.destination.toUpperCase();
    }
    let tiersList = []
    if (this.price.tier != undefined) {
      this.price.tier.forEach(element => {
        tiersList.push(element.item_text)
      });
      this.price.tier = tiersList;
    }
    this.listPrice = [];
    this.toDateflag = false;
    this.vernostServiceService.searchPrice(this.price).subscribe(
      (res: any) => {
        this.loader = false;
        if (res.status == 200) {
          this.resetPrice();
          this.listPrice = res.data;
          this.totalItems = res.data.count;
        } else if (res.status == 409) {
          this.toastService.error("Already exist, Please enter valid data!");
        }
      },
      err => {
        if (err.status == 409) {
          this.toastService.error("Already exist, Please enter valid data!");
        } else {
          this.toastService.error(err.message);
        }
      }
    );
  }

  resetPrice = () => {
    this.price.tier = [];
    this.price.origin = "";
    this.price.destination = "";
    this.price.tpmValue = "";
    this.price.FROM_DATE = "";
    this.price.TO_DATE = "";
    this.toDateflag = true;
    this.price.fp1 = "";
    this.price.fp2 = "";
    this.price.fp3 = "";
    this.price.fp4 = "";
    this.price.fp5 = "";
    this.price.fp6 = "";
    this.price.fp7 = "";
  };

  searchTpmData = () => {
    let tiersList = []
    if (this.price.tier) {
      this.price.tier.forEach(element => {
        tiersList.push(element.item_text)
      });
      this.price.tier = tiersList;
    }
    this.vernostServiceService.getTpmList(this.price).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.price.tpmValue = res.data[0].tpm_value;
        } else if (res.status == 300) {
          this.toastService.error(res.message, "Invalid OnD!", {
            timeOut: 1000
          });
        }
      },
      err => { }
    );
  };

  pageCount(count) {
    this.p = count;
    console.log("P:::", this.p);
  }

  getPrice = () => {
    // this.loader = true;
    this.searchlist = false;
    this.noresult = "";
    this.listPrice = [];
    let tiersList = []
    console.log("this.price.tier", this.price.tier);
    if (this.price.tier != undefined) {
      this.price.tier.forEach(element => {
        tiersList.push(element.item_text)
      });
      this.price.tier = tiersList;
    }
    let data = this.price;
    data["pagination"] = this.p;

    // this.vernostServiceService.getPriceList(data).subscribe(
    //   (res: any) => {
    //     console.log("dataaaaaaaaaa", res);
    //     // this.isedit = "";
    //     this.totalItems = res.count;
    //     this.listPrice = res.data;
    //     if (
    //       this.listPrice.length == 0 ||
    //       this.listPrice == undefined ||
    //       this.listPrice == ""
    //     ) {
    //       this.noresult = "Result Not Found";
    //       this.loader = false;
    //     } else {
    //       this.loader = false;
    //     }
    //   },
    //   err => { }
    // );
  };

  deleteData = (price, deleteContent) => {
    this.deleteID = price;
    this.openModal(deleteContent);
  };

  cancel = () => {
    this.isedit = "";
    this.ishidden = true;

    this.issave = false;
    this.isediticon = true;
    this.iscancel = false;

  }
  isedit: any = "";
  FP1: any;
  FP2: any;
  FP3: any;
  FP4: any;
  FP5: any;
  FP6: any;
  FP7: any;
  status: any;

  editData = (priceID, editContent, index) => {

    console.log("editDatasssss", priceID, "jjj", index);

    this.editID = priceID;
    console.log("this.listPrice", this.listPrice);


    for (var i = 0; i < this.listPrice.length; i++) {
      if (this.listPrice[i].ID == priceID) {
        this.FP1 = this.listPrice[i].FP1;
        this.FP2 = this.listPrice[i].FP2;
        this.FP3 = this.listPrice[i].FP3;
        this.FP4 = this.listPrice[i].FP4;
        this.FP5 = this.listPrice[i].FP5;
        this.FP6 = this.listPrice[i].FP6;
        this.FP7 = this.listPrice[i].FP7;
        this.status = this.listPrice[i].STATUS;
      }
      console.log("this.status", this.status);
    }
    this.selectedValue = this.status;
    // this.openModal(editContent);
    this.isedit = index;
    this.issave = true;
    this.isediticon = false;
    // this.islabel = false;
  };

  typeof(str) {
    return typeof (str);
  }
  deletePrice = () => {
    const obj = {
      ID: this.deleteID,
      USER_ID: localStorage.getItem("uid")
    };
    this.vernostServiceService.deletePrice(obj).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.closeModal();
          this.searchPrice();
          this.toastService.success(res.message);
          //this.modalRef.hide();
        }
      },
      err => {
        console.log(err);
      }
    );
  };

  selectdropdown(val) {
    this.status = val.target.value;
    console.log(this.status);

  }


  Save = () => {

    console.log("price::::", this.FP1);
    const obj = {
      ID: this.editID,
      FP1: this.FP1,
      FP2: this.FP2,
      FP3: this.FP3,
      FP4: this.FP4,
      FP5: this.FP5,
      FP6: this.FP6,
      FP7: this.FP7,
      STATUS: this.status,
      USER_ID: localStorage.getItem("uid")
    };

    // this.loader = true;
    this.vernostServiceService.updatePrice(obj).subscribe(
      //  
      (res: any) => {
        this.searchPrice();
        console.log("before:::::::::::::")
        this.toastService.success(res.message);

        this.issave = false;
        this.isedit = ""

      },
      err => {
        this.toastService.error("Something went wrong");
      }
    );

  };


  statusPrice = type => {
    const obj = {
      ID: this.editID,
      STATUS: type,
      USER_ID: localStorage.getItem("uid")



    };
    this.vernostServiceService.updatePrice(obj).subscribe(
      (res: any) => {
        this.closeModal();
        this.searchPrice();
        this.toastService.success(res.message);
      },
      err => {
        this.toastService.error("Something went wrong");
      }
    );
  };

  // selectAll(e, select: NgModel, values) {
  //   if (select.value.length == 1) {
  //     select.update.emit(values);
  //   } else {
  //     select.update.emit([]);
  //   }
  // }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

}